module.exports = "pegasus_template/assets/themecapture1/sidebar/200.png";